
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/dpa",
      function () {
        return require("private-next-pages/services/dpa.tsx");
      }
    ]);
  